// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-GuestlistOverlayHeader-module__guestlistOverlayTitle__iuK8N";
var _2 = "assets-js-ViewInvitation-components-Guestlist-GuestlistOverlayHeader-module__guestlistOverlayTop__cMzrv";
export { _1 as "guestlistOverlayTitle", _2 as "guestlistOverlayTop" }
